import { ToolbarGroup } from "@wordpress/components";

export default function AllBlockControls(props) {
  const { setAttributes, attributes } = props;

  return (
    <>
      <ToolbarGroup></ToolbarGroup>
    </>
  );
}
